import apiClient from './apiClient'
export { getCompanyDetail, getCompanyEvaluateList }
async function getCompanyDetail(params) {
  const res = await apiClient.get('getCompanyDetail.do', { params })
  return res.data
}

async function getCompanyEvaluateList(params) {
  const res = await apiClient.get('getEvaluateList.do', { params })
  return res.data
}
